module.exports = __webpack_public_path__ + "img/hint-one-mobile-eng.d01b34c9.png";